export default __webpack_public_path__ + "static/media/tablet-image.4d5ef01a.png";